import React from 'react';
import { useEffect, useState } from 'react';
import './App.css';
import ProjectList from './ProjectList';

function App() {
  const [projects, setProjects] = useState([]);
  const [projectsComingSoon, setProjectsComingSoon] = useState([]);
  const [projectsClosed, setProjectsClosed] = useState([]);
  useEffect(() => {
    async function getProjects() {
      const res = await fetch('https://backend-black.vercel.app/api/project', {
        mode: 'cors',
        credentials: 'include',
      });
      const projData = await res.json();
      if (projData && projData.projects) setProjects(projData.projects);
    }

    async function getComingProjects() {
      const res = await fetch(
        'https://backend-black.vercel.app/api/projectsComing',
        {
          mode: 'cors',
          credentials: 'include',
        },
      );
      const projData = await res.json();
      if (projData && projData.projects)
        setProjectsComingSoon(projData.projects);
    }

    async function getClosedProjects() {
      const res = await fetch(
        'https://backend-black.vercel.app/api/projectsClosed',
        {
          mode: 'cors',
          credentials: 'include',
        },
      );
      const projData = await res.json();
      if (projData && projData.projects) setProjectsClosed(projData.projects);
    }

    getProjects();
    getComingProjects();
    getClosedProjects();
  }, []);

  return (
    <main>
      <ProjectList
        projects={projects}
        projectsComingSoon={projectsComingSoon}
        projectsClosed={projectsClosed}
      />

      <br />
    </main>
  );
}

export default App;
